import React, { useState, useEffect, useContext } from 'react';
import ContentsBox from '../../components/common/ContentsBox';

import VodListSkeleton from '../../components/skeleton/VodListSkeleton';
import { LayoutContext } from '../../context/layoutContext';

import Flicking, { ViewportSlot } from '@egjs/react-flicking';
import { Arrow } from '@egjs/flicking-plugins';

import '@egjs/react-flicking/dist/flicking.css';
import '@egjs/react-flicking/dist/flicking-inline.css';
import '@egjs/flicking-plugins/dist/arrow.css';

const MediaSwiperList = ({
  list,
  showCnt = 4,
  type,
  wrap,
  goDetail,
  playBtn,
  colorFix,
  preArrow,
  nextArrow,
  contetentHeight,
  paginationCnt,
  optionType,
  animation,
  imgOpacity,
  filckingChange,
}) => {
  const { matchese } = useContext(LayoutContext);

  const [mediaList, setMediaList] = useState([]);

  useEffect(() => {
    setMediaList(list);
  }, [list]);

  useEffect(() => {
    let panel = document.querySelectorAll('.Pagination_Panel');

    if (optionType === 'pagination' && panel.length > 0) {
      paginationCnt(panel);
    }
  }, [mediaList, optionType]);

  const listCondition = list => {
    if (!list.length > 0) return;
    let result = [];

    return (
      <>
        {list.map((item, idx) => {
          result.push(
            <ContentsBox
              key={`box_${idx}`}
              data={item}
              width={wrap ? `${100 / 2}%` : `${100 / showCnt}%`}
              contetentHeight={contetentHeight}
              type={type}
              goDetail={goDetail}
              colorFix={colorFix}
              playBtn={playBtn}
              imgOpacity={imgOpacity}
              animation={animation}
            />,
          );

          if (result.length === showCnt) {
            let _result = [...result];
            result = [];

            return (
              <div
                className={optionType === 'pagination' ? 'Pagination_Panel' : ''}
                key={`contents_${idx}`}
                style={{ display: 'flex', width: '100%', flexWrap: wrap ? 'wrap' : 'nowrap', justifyContent: 'flex-start' }}
              >
                {_result}
              </div>
            );
          }
          if (idx === list.length - 1) {
            return (
              <div
                className={optionType === 'pagination' ? 'Pagination_Panel' : ''}
                key={`content_${idx}`}
                style={{ display: 'flex', width: '100%', flexWrap: wrap ? 'wrap' : 'nowrap', justifyContent: 'flex-start' }}
              >
                {result}
              </div>
            );
          }
        })}
      </>
    );
  };

  let _plugins = [new Arrow()];

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', padding: '5px 0' }}>
      {mediaList.length > 0 ? (
        <Flicking circular={false} plugins={_plugins} onChanged={filckingChange}>
          {listCondition(mediaList)}
          <ViewportSlot>
            <span
              id='prevBtn'
              ref={preArrow}
              className={`flicking-arrow-prev ${optionType === 'sideArrow' ? 'arrow-show-prev' : ''}`}
            ></span>
            <span
              id='nextBtn'
              ref={nextArrow}
              className={`flicking-arrow-next ${optionType === 'sideArrow' ? 'arrow-show-next' : ''}`}
            ></span>
          </ViewportSlot>
        </Flicking>
      ) : (
        <VodListSkeleton
          wrap={matchese}
          list={true}
          boxHeight={contetentHeight}
          listAdd={showCnt > 4}
          showCnt={showCnt}
          oneData={showCnt === 1}
        />
      )}
    </div>
  );
};

export default MediaSwiperList;
